import React from 'react';
import { mergeStyles } from '@bingads-webui-react/fabric-control';

const dividerStyles = mergeStyles({
  height: 1,
  background: '#EDEBE9',
});

export const HorizontalDivider = () => <div className={dividerStyles} />;
